import React, { useState, useEffect } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card, Row, Col, Accordion, CardDeck, Modal } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import BoxItemDropDown from '../components/BoxItemDropDown'
import BoxItemDropDownDownGroup from '../components/BoxItemDropDownDownGroup'
import '../css/BoxItem.css'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import axiosConfig from '../config/axiosConfig'
import DNDcomponent from '../components/DNDcomponent'
import { v4 } from "uuid"
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom'; // Add this line



import Select from "react-select";

import HeadingBox from '../components/HeadingBox'

const headers = {
    'Content-Type': 'application/json',
    'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
}

const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
]

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "black" : "black",
        backgroundColor: state.isSelected ? "#7367f0" : "white",
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        borderColor: "#7367f0",
    }),
};



function swalConfirm(groupId, branchID) {
 debugger
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.isConfirmed) {
            axiosConfig.post("Portal/DeleteVRNGroupMapping",
            {
                    GroupId: groupId,
                    UserBranchID: branchID,
            }
        )
            .then(response => {
                debugger
                let responseCode = response.data.status.responseCode;

                if (responseCode === "00") {

                    Swal.fire(
                        'Deleted!',
                        'Item has been deleted',
                        'success'
                    )
                    localStorage.setItem('tabClosed', 'false');
                   window.location.reload(); 
                }
                else
                {
                    Swal.fire({
                        title: response.data.status.errorMessage,
                        text: 'Error While deleting!',
                        icon: 'error',
                        confirmButtonText: 'Okay'
                      });
                }


    })
        
            .catch(error => {

                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Error While deleting!',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                  });

            })
           


           
        }
    })
}




function Child({ items }) {
    return (
        items.vrnMapping.map((el, index) => {
            return (
                <div className="box-item btn btn-default w-100">
                    <BoxItemDropDown index={index} name={el.vrn} accordionSubItems={el.paNs} ></BoxItemDropDown>
                </div>
            )
        })
    );
}

function VRNGroupMappingCard({ items, branchID, mappingData , setItems }) {
    
    const [showModel, setshowModel] = React.useState(false);

    const [selectedGroupID, setselectedGroupID] = React.useState(0);
    const [selectedVRN, setselectedVRN] = React.useState(null);

    const [VRN, setVRN] = React.useState(null);
    const [groupName, setgroupName] = React.useState(0);
    // Add this below line to initialize the groupVRN state
    const [groupVRN, setGroupVRN] = React.useState(items.groupVRN); 
    


    let tempArray = items;
    let splitArray = []
    let size = 20;

    let items2 = [];

    if (mappingData.vrnMapping != undefined) {


        for (let i = 0; i <= mappingData.vrnMapping.length - 1; i++) {
            items2.push(
                {
                    value: mappingData.vrnMapping[i].id,
                    label: mappingData.vrnMapping[i].vrn
                }
            )
        }
    }

    for (let i = 0; i < tempArray.groupVRN.length; i += size) {
        splitArray.push(tempArray.groupVRN.slice(i, i + size))
    }

    function AddCardMapping(group, groupName) {
        setshowModel(true)
        setselectedGroupID(group)
        setgroupName(groupName)
    }

    // function EditGroupName(GroupID) {

    //     Swal.mixin({
    //         input: 'text',
    //         confirmButtonText: 'Next &rarr;',
    //         showCancelButton: true,
    //     }).queue([
    //         {
    //             title: 'Edit Group Name',
    //         }
    //     ]).then((result) => {
    //         if (result.value) {
    //             const answers = JSON.stringify(result.value)
    //             axiosConfig.post("Portal/EditGroupName",
    //                 {
    //                     GroupId: GroupID,
    //                     GroupName: result.value[0],
    //                     UserBranchID: branchID,
    //                 })
    //                 .then(Response => {
    //                     Swal.fire({
    //                         title: Response.data.status.description,
    //                         text: 'Group Name Changed',
    //                         icon: 'success',
    //                         confirmButtonText: 'Okay'
    //                     })
    //                 })
    //                 .catch(error => {
    //                     Swal.fire({
    //                         title: error.response.data.errorMessage,
    //                         text: 'Some Error !',
    //                         icon: 'error',
    //                         confirmButtonText: 'Okay'
    //                     })
    //                 })
    //         }
    //     })
    // }

    function EditGroupName(GroupID,GroupName) {
        Swal.mixin({
          
          input: 'text',
          inputValue:GroupName,
          confirmButtonText: 'Save',
          showCancelButton: true,
        }).queue([
          {
            title: 'Edit Group Name',
          }
        ]).then((result) => {
          if (result.value) {
            const answers = JSON.stringify(result.value);
            axiosConfig.post("Portal/EditGroupName", {
              GroupId: GroupID,
              GroupName: result.value[0],
              UserBranchID: branchID,
            })
            .then(Response => {
              Swal.fire({
                title: Response.data.status.description,
                text: 'Group Name Changed',
                icon: 'success',
                confirmButtonText: 'Okay'
              }).then(() => {
                // Update the group name in the grid
                const updatedGroupVRN = [...items.groupVRN];
                const groupIndex = updatedGroupVRN.findIndex(group => group.groupID === GroupID);
                if (groupIndex !== -1) {
                    updatedGroupVRN[groupIndex].groupName = result.value[0];
                    setGroupVRN(updatedGroupVRN); // Update the groupVRN state
                }
              });
            })
            .catch(error => {
              Swal.fire({
                title: error.response.data.errorMessage,
                text: 'Some Error !',
                icon: 'error',
                confirmButtonText: 'Okay'
              });
            });
          }
        });
      }
      
      
    function DeleteGroup(GroupID) {
        swalConfirm(GroupID, branchID ,items,setGroupVRN);
    
        debugger
        
    }

    function closeModel() {
        setshowModel(false)
    }

    // function changeVRN(selectedOption) {
    //     setselectedVRN(selectedOption.value)
    //     setVRN(selectedOption.label)

    // }

    function changeVRN(selectedOptions) {
        debugger;
        const newValues = selectedOptions.map(option => option.value);
        const newLabels = selectedOptions.map(option => option.label);
    
        setselectedVRN(newValues);
        setVRN(newLabels);
    }

    // function onSubmit() {

    //     setshowModel(false)

    //     console.log("GroupID: " + selectedGroupID)
    //     console.log("GroupName: " + groupName)

    //     console.log("SelectedVRN: " + selectedVRN)
    //     console.log("VRN: " + VRN)

    //     axiosConfig.post("Portal/AddGroupVehicle",
    //         {

    //             GroupID: selectedGroupID,
    //             MappingID: selectedVRN,
    //             GroupName: groupName,
    //             VRN: VRN,
    //             UserBranchID: localStorage.getItem('selectedBranch')

    //         }
    //     )
    //         .then(Response => {

    //             let responseCode = Response.data.status.responseCode

    //             if (responseCode === '00') {
    //                 Swal.fire(
    //                     {
    //                         text: Response.data.status.description,
    //                         icon: 'success'
    //                     }
    //                 )
    //             }
    //             else {
    //                 Swal.fire(
    //                     {
    //                         text: Response.data.status.description,
    //                         icon: 'error'
    //                     }
    //                 )
    //             }

    //             console.log(Response.data)
    //         })
    //         .catch(error => {
    //             console.log("Error !! Not deleted PAN")

    //             Swal.fire(
    //                 'Error',
    //                 'Error! Please try again',
    //                 'error'
    //             )
    //         })


    // }

    
    
      
//   function onSubmit() {
//     setshowModel(false);
//     debugger
//     console.log("GroupID: " + selectedGroupID);
//     console.log("GroupName: " + groupName);
//     console.log("SelectedVRN: " + selectedVRN);
//     console.log("VRN: " + VRN);

//     axiosConfig.post("Portal/AddGroupVehicle", {
//       GroupID: selectedGroupID,
//       MappingID: selectedVRN,
//       GroupName: groupName,
//       VRN: VRN,
//       UserBranchID: localStorage.getItem('selectedBranch')
//     })
//     .then(Response => {
//       let responseCode = Response.data.status.responseCode;

//       if (responseCode === '00') {
//         Swal.fire({
//           text: Response.data.status.description,
//           icon: 'success'
//         }).then(() => {
//           // Update the grid with the new group
//           const newGroup = {
//             groupID: selectedGroupID,
//             groupName: groupName,
//             vrnModel: [] // Provide the required properties for vrnModel
//           };
//           setItems(prevItems => ({
//             ...prevItems,
//             groupVRN: [...prevItems.groupVRN, newGroup]
//           }));
//         });
//       } else {
//         Swal.fire({
//           text: Response.data.status.description,
//           icon: 'error'
//         });
//       }

//       console.log(Response.data);
//     })
//     .catch(error => {
//       console.log("Error !! Not deleted PAN");

//       Swal.fire({
//         title: 'Error',
//         text: 'Error! Please try again',
//         icon: 'error'
//       });
//     });
//   }

  
function onSubmit() {
    setshowModel(false);
    debugger
    console.log("GroupID: " + selectedGroupID);
    console.log("GroupName: " + groupName);
    console.log("SelectedVRN: " + selectedVRN);
    console.log("VRN: " + VRN);

    axiosConfig
      .post("Portal/AddGroupVehicle", {
        GroupID: selectedGroupID,
        MappingID: selectedVRN,
        GroupName: groupName,
        VRN: VRN,
        UserBranchID: localStorage.getItem("selectedBranch"),
      })
      .then((response) => {
        debugger
        let responseCode = response.data.status.responseCode;

        if (responseCode === "00") {
            
          Swal.fire({
            text: response.data.status.description,
            icon: "success",
          }).then(() => {
            // Update the grid with the new group
            localStorage.setItem('tabClosed', 'false');
            window.location.reload(); // Reload the page

          });


        } else {
          Swal.fire({
            text: response.data.status.description,
            icon: "error",
          });
        }

        console.log(response.data);
      })
      .catch((error) => {
        console.log("Error !! Not deleted PAN");

        Swal.fire({
          title: "Error",
          text: "Error! Please try again",
          icon: "error",
        });
      });
  }

  
  
  


  
  
  
  
  

    return (
        
        <div>
            <Modal show={showModel} onHide={closeModel} animation={true} centered style={{ zIndex: 99999 }}>
                <Modal.Header closeButton>
                    <Modal.Title>Add vehicle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form >
                        <div className="modal-body">
                        <Select
      className=""
      options={items2}
      styles={customStyles}
      onChange={changeVRN}
      isMulti={true} // This enables multi-select functionality
     
    />

                            <div style={{ display: "none" }}>

                                <label id="1"> {selectedGroupID} </label>
                                <label id="2"> {selectedVRN} </label>

                            </div>


                        </div>
                        <div className="modal-footer">
                            <Button variant="secondary" onClick={closeModel}>Close</Button>
                            <Button className="btn btn-shell" onClick={onSubmit}>Add</Button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Accordion>
                <Row className="m-0">
                    <Col>
                        {/* {rows} */}
                        {splitArray.map((el, index) => {
                            return (
                                <Card className="card p-3 text-center rounded">
                                    <Card.Title className="text-left">
                                        Vehicle Groups
                                    </Card.Title>

                                    {el.map((el2, index) => {
                                        return (

                                            <div>

                                                {el2.groupID != '0' ?

                                                    <ul className="list-inline mb-1 pull-right">
                                                        <li id={el2.groupID + index}><a href="#" onClick={() => AddCardMapping(el2.groupID, el2.groupName)}><FeatherIcon className="iconspacing" icon="plus-square" size="18" color="green" /></a></li>
                                                        <li id={el2.groupID + index} className="text-right"><a href="#" onClick={() => EditGroupName(el2.groupID,el2.groupName)}><FeatherIcon className="iconspacing" icon="edit" size="18" /></a></li>
                                                        <li id={el2.groupID + index}><a href="#" onClick={() => DeleteGroup(el2.groupID)}><FeatherIcon className="iconspacing" icon="trash-2" size="18" color="red" /></a></li>
                                                    </ul>

                                                    :

                                                    <div> </div>
                                                }
                                                <BoxItemDropDownDownGroup index={index} groupID={el2.groupID} name={el2.groupName} accordionSubItems={el2.vrnModel} deleteDialog='yes' ></BoxItemDropDownDownGroup>
                                                <hr />

                                            </div>



                                        )
                                    })}

                                </Card>
                            )
                        })}
                    </Col>
                </Row>
            </Accordion>


        </div>


    )
}
  
  
function CardChild(props) {
    const items = props.items;
    const indexAccordion = props.indexAccordion
    
    return (
        items.map((el, index) => {
            return (
                <div className="box-item btn btn-default w-100">
                    {/* <BoxItemDropDown index={index} name={el.vrn} accordionSubItems={el.paNs} deleteDialog='no' ></BoxItemDropDown>

                    <BoxCard index={index} name={el.vrn} accordionSubItems={el.paNs} deleteDialog='no' ></BoxCard> */}
                    {el.vrn}
                </div>
            )
        })
    );
}





function ManageVehicleGroup(props) {

    const [CardMappingData, setCardMappingData] = useState([]);
    const [vrnMappingData, setVRNMappingData] = useState([]);
    const [tagName, setTagName] = useState('');
    const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId)
    const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber)
    const [selectedMapFunction, setSelectedMapFunction] = useState(false)
    // Define the items state and the setItems function
  const [items, setItems] = useState({
    groupVRN: [] // Add other required properties for the groupVRN array
  });

    const history = useHistory(); // Create history object
    
    function handleBackButtonClick() {

        history.push('/Manage'); // Replace '/other-page' with the path of the desired page
      }
    
    const [dnd, setDND] = useState({
        "source": {
            title: "source",
            items: []
        },
        "dest": {
            title: "dest",
            items: []
        }
    })

   
    function mapVRNGroupingAPI() {
        debugger
        console.log('inside here');

        let GroupVRN = []
        dnd.dest.items.map((el, index) => {
            GroupVRN.push(el.name)
        })

        axiosConfig.post('Portal/VRNGroupMapping', {
            "CardVRNMappingMasterId": GroupVRN,
            "GroupName": tagName,
            "UserBranchID": props.data.selectedBranchId
        }, {
            headers: headers
        })
            .then((res) => {
                


                console.log('inside here');

                Swal.fire({
                    icon: 'success',
                    title: 'Card Grouping Submitted',
                    text: res.data.status.description,
                })
                debugger
                setDND(prevState => {
                    return {
                        ...prevState,
                        "dest": {
                            title: "dest",
                            items: []
                        }

                    }
                })

                setTagName("")
                 getVRNMapping()
                 localStorage.setItem('tabClosed', 'false');
                 window.location.reload(); // Reload the page

            })
            .catch((error) => {
                debugger
                Swal.fire({
                    icon: 'error',
                    title: error.response.data.errorMessage
                })

            })

            .finally(() => {
            });
    };

    function getVCardMapping() {

        axiosConfig.post('Portal/GetCardMappingForGroup', {
            "UserBranchID": props.data.selectedBranchId
        }, {
            headers: headers
        })
            .then((res) => {
                setCardMappingData(res.data);
                for (var i = 0; i < res.data.vrnMapping.length; i++) {
                    setDND(prev => {
                        return {
                            ...prev,
                            source: {
                                title: "source",
                                items: [
                                    {
                                        id: 'source-' + v4(),
                                        name: res.data.vrnMapping[i].id,
                                        caption: res.data.vrnMapping[i].vrn
                                    },
                                    ...prev.source.items
                                ]
                            }
                        }
                    })
                }
            })
            .catch(console.error)
            .finally(() => {
                Swal.close();
            });
    }

    function getVRNMapping() {

        axiosConfig.post('Portal/GetVRNGroupMapping', {
            "UserBranchID": props.data.selectedBranchId,
            "DefaultGroup": false
        },
            {
                headers: headers
            })
            .then((res) => {
                setVRNMappingData(res.data);
            })
            .catch(console.error)
            .finally(() => {
                //Swal.close();
            });
    }

    useEffect(async () => {

        Swal.fire({
            title: 'Please Wait ...',
            onBeforeOpen() {
                Swal.showLoading()
            },
            onAfterClose() {
                Swal.hideLoading()
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: false,
            showConfirmButton: false
        })

        setDND(prevState => {
            return {
                ...prevState,

                "source": {
                    title: "source",
                    items: []
                },
                "dest": {
                    title: "dest",
                    items: []
                }

            }
        })



        getVCardMapping();
        getVRNMapping();
    }, [props.data.selectedBranchNumber]);


    useEffect(async () => {

        // Swal.fire({
        //     title: 'Please Wait ...',
        //     onBeforeOpen() {
        //         Swal.showLoading()
        //     },
        //     onAfterClose() {
        //         Swal.hideLoading()
        //     },
        //     allowOutsideClick: false,
        //     allowEscapeKey: false,
        //     allowEnterKey: false,
        //     showCancelButton: false,
        //     showConfirmButton: false
        // })

        // setDND(prevState => {
        //     return {
        //         ...prevState,

        //         "source": {
        //             title: "source",
        //             items: []
        //         },
        //         "dest": {
        //             title: "dest",
        //             items: []
        //         }

        //     }
        // })



        // getVCardMapping();
        getVRNMapping();
    }, []);


   


    const handleDragEnd = ({ destination, source, draggableId }) => {
        if (destination != null) {

            if (!destination || !source) {
                return
            }

            if (source.index === destination.index && source.droppableId === destination.droppableId) {
                return
            }

            let itemCopy = { ...dnd[source.droppableId].items[source.index] }

            setDND(prev => {
                prev = { ...prev }
                prev[source.droppableId].items.splice(source.index, 1)

                prev[destination.droppableId].items.splice(destination.index, 0, itemCopy)
                return prev
            })

        }
    }

    function MapButton() {
    
        return (
    
            <Card.Footer>
                <Button className="w-35"
                    variant="shell"
                    onClick={() => mapVRNGroupingAPI()}
                >
                    Save Group</Button>
            </Card.Footer>
        )
    
    return (
        <>
        </>
    )
    }

    return (
        <>
            <Container>
            
            <Row className="align-items-center">
        
        <Button variant="warning myBtn" onClick={handleBackButtonClick} >
          Back
        </Button>
        </Row>


            <div >
                                    <h4 className="card-title"> <h4>Manage Vehicle Groups</h4></h4>
                                </div>
      
                <HeadingBox title="Vehicle Groups enable you to track the performance of your selected vehicles together"></HeadingBox>


                <Row className="m-0">
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Col>
                            <CardDeck>
                                <Card key="cardGroup" className="card p-3 text-center rounded" style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
                                    <Card.Title className="text-left">
                                        Select Vehicles
                                    </Card.Title>
                                    {/* <input id="filter" className="form-control round" type="text" placeholder="Search vehicles in vehicle group..." /> */}
                                    {dnd.source && <DNDcomponent droppableId="source" droppableKey="vrn" vrndata={dnd.source} showAccordion={false} />}
                                </Card>


                                <form 
                                // onSubmit={() => mapVRNGroupingAPI()}
                                >

                               
                                    <Card key="vrnGroup" className="card p-3 text-center rounded" style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
                                        <Card.Title className="text-left">
                                            <div style={{ marginBottom: 5 }}>Create Vehicle Groups</div>


                                            <div style={{ marginBottom: 5 }}>

                                                <small>Please drag vehicles here to make Vehicle Groups.</small>
                                                {/* <p className="mb-0 header small-font" style={{fontWeight:'100',fontSize:'12px',Paddingleft:'2px',paddingTop:'5px'}}>{"Please drag vehicles here to make Vehicle Groups." }</p> */}

                                            </div>




                                            <input id="filter" className="form-control round" type="text" pattern="^[a-zA-Z0-9]+$" placeholder="Enter Group Name" onChange={e => setTagName(e.target.value)} maxLength={50}  value={tagName} title="Only alpha numeric characters are allowed" required/>
                                        </Card.Title>
                                        {dnd.dest && <DNDcomponent droppableId="dest" key="mapped" vrndata={dnd.dest} />}
                                        <Card.Footer>
                                        {
                                            MapButton()
                                        }
                                        {/* <Button className="w-25 text-white"
                                                variant="shell"
                                                // type="submit"
                                                onClick={mapVRNGroupingAPI()}
                                            >Group</Button> */}
                                            {/* <button type="submit" className="w-25 text-white" variant="shell">Group</button> */}
                                        </Card.Footer>
                                    </Card>
                               


                                </form>

                            </CardDeck>
                        </Col>
                    </DragDropContext>
           
                </Row>
                {vrnMappingData.groupVRN && <VRNGroupMappingCard items={vrnMappingData} branchID={props.data.selectedBranchId} mappingData={CardMappingData}
                //new code
                // setItems={setItems} // Pass the setItems function as a prop
                //end of new code
                 />}
            </Container >
        </>

    );
}

export default ManageVehicleGroup;


// import React, { useState, useEffect } from 'react';
// import { Navbar, Nav, Container, Button, Dropdown, Card, Row, Col, Accordion, CardDeck, Modal } from 'react-bootstrap';
// // import 'bootstrap/dist/css/bootstrap.css';
// import FeatherIcon from 'feather-icons-react';
// import '../../node_modules/font-awesome/css/font-awesome.min.css';
// import BoxItemDropDown from '../components/BoxItemDropDown';
// import BoxItemDropDownDownGroup from '../components/BoxItemDropDownDownGroup';
// import '../css/BoxItem.css';
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import axiosConfig from '../config/axiosConfig';
// import DNDcomponent from '../components/DNDcomponent';
// import { v4 } from "uuid";
// import Swal from 'sweetalert2/dist/sweetalert2.js';
// import { useHistory } from 'react-router-dom';
// import { Link } from 'react-router-dom'; // Add this line

// import Select from "react-select";

// import HeadingBox from '../components/HeadingBox';

// const headers = {
// 'Content-Type': 'application/json',
// 'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
// };

// const options = [
// { value: 'chocolate', label: 'Chocolate' },
// { value: 'strawberry', label: 'Strawberry' },
// { value: 'vanilla', label: 'Vanilla' }
// ];

// const customStyles = {
// option: (provided, state) => ({
// ...provided,
// color: state.isSelected ? "black" : "black",
// backgroundColor: state.isSelected ? "#7367f0" : "white",
// }),
// control: (provided) => ({
// ...provided,
// borderRadius: "20px",
// borderColor: "#7367f0",
// }),
// };


// function Child({ items }) {
// return (
// items.vrnMapping.map((el, index) => {
// return (
// <div className="box-item btn btn-default w-100">
// <BoxItemDropDown index={index} name={el.vrn} accordionSubItems={el.paNs} ></BoxItemDropDown>
// </div>
// );
// })
// );
// }

// function VRNGroupMappingCard({ items, branchID, mappingData,setItems }) {
// const [showModel, setshowModel] = useState(false);
// const [selectedGroupID, setselectedGroupID] = useState(0);
// const [selectedVRN, setselectedVRN] = useState(0);
// const [VRN, setVRN] = useState(0);
// const [groupName, setgroupName] = useState(0);
// const [groupVRN, setGroupVRN] = useState(items.groupVRN);

// let tempArray = items;
// let splitArray = [];
// let size = 3;

// let items2 = [];

// useEffect(() => {
//     setGroupVRN(items.groupVRN);
//   }, [items.groupVRN]);


// if (mappingData.vrnMapping != undefined) {
//     for (let i = 0; i <= mappingData.vrnMapping.length - 1; i++) {
//         items2.push({
//             value: mappingData.vrnMapping[i].id,
//             label: mappingData.vrnMapping[i].vrn
//         });
//     }
// }

// for (let i = 0; i < tempArray.groupVRN.length; i += size) {
//     splitArray.push(tempArray.groupVRN.slice(i, i + size));
// }



// function AddCardMapping(group, groupName) {
//     setshowModel(true);
//     setselectedGroupID(group);
//     setgroupName(groupName);
// }

// function EditGroupName(GroupID) {
//     Swal.mixin({
//         input: 'text',
//         confirmButtonText: 'Next &rarr;',
//         showCancelButton: true,
//     }).queue([
//         {
//             title: 'Edit Group Name',
//         }
//     ]).then((result) => {
//         if (result.value) {
//             const answers = JSON.stringify(result.value);
//             axiosConfig.post("Portal/EditGroupName", {
//                 GroupId: GroupID,
//                 GroupName: result.value[0],
//                 UserBranchID: branchID,
//             })
//                 .then(Response => {
//                     Swal.fire({
//                         title: Response.data.status.description,
//                         text: 'Group Name Changed',
//                         icon: 'success',
//                         confirmButtonText: 'Okay'
//                     }).then(() => {
//                         const updatedGroupVRN = [...items.groupVRN];
//                         const groupIndex = updatedGroupVRN.findIndex(group => group.groupID === GroupID);
//                         if (groupIndex !== -1) {
//                             updatedGroupVRN[groupIndex].groupName = result.value[0];
//                             setGroupVRN(updatedGroupVRN);
//                         }
//                     });
//                 })
//                 .catch(error => {
//                     Swal.fire({
//                         title: error.response.data.errorMessage,
//                         text: 'Some Error !',
//                         icon: 'error',
//                         confirmButtonText: 'Okay'
//                     });
//                 });
//         }
//     });
// }

// function DeleteGroup(GroupID) {
//      swalConfirm(GroupID, branchID);
//     debugger;
    
          
          
// }

// function swalConfirm(groupId, branchID) {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then((result) => {
//       if (result.isConfirmed) {
//         Swal.fire(
//           'Deleted!',
//           'Item has been deleted',
//           'success'
//         );
  
//         axiosConfig.post("Portal/DeleteVRNGroupMapping", {
//           GroupId: groupId,
//           UserBranchID: branchID,
//         })
//         .then(response => {
//             debugger
//             window.location.reload();
//         })
//         .catch(error => {
//           // Handle error
//         });
//       }
//     });
//   }
      

// function closeModel() {
//     setshowModel(false);
// }

// function changeVRN(selectedOption) {
//     setselectedVRN(selectedOption.value);
//     setVRN(selectedOption.label);
// }

// function onSubmit() {
//     setshowModel(false);
//     console.log("GroupID: " + selectedGroupID);
//     console.log("GroupName: " + groupName);
//     console.log("SelectedVRN: " + selectedVRN);
//     console.log("VRN: " + VRN);

//     axiosConfig
//         .post("Portal/AddGroupVehicle", {
//             GroupID: selectedGroupID,
//             MappingID: selectedVRN,
//             GroupName: groupName,
//             VRN: VRN,
//             UserBranchID: localStorage.getItem("selectedBranch"),
//         })
//         .then((response) => {
//             debugger;
//             let responseCode = response.data.status.responseCode;

//             if (responseCode === "00") {
//                 Swal.fire({
//                     text: response.data.status.description,
//                     icon: "success",
//                 }).then(() => {
//                     window.location.reload();
//                 });
//             } else {
//                 Swal.fire({
//                     text: response.data.status.description,
//                     icon: "error",
//                 });
//             }

//             console.log(response.data);
//         })
//         .catch((error) => {
//             console.log("Error !! Not deleted PAN");

//             Swal.fire({
//                 title: "Error",
//                 text: "Error! Please try again",
//                 icon: "error",
//             });
//         });
// }

// return (
//     <div>
//         <Modal show={showModel} onHide={closeModel} animation={true} centered style={{ zIndex: 99999 }}>
//             <Modal.Header closeButton>
//                 <Modal.Title>Add vehicle</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <form>
//                     <div className="modal-body">
//                         <Select
//                             className=""
//                             options={items2}
//                             styles={customStyles}
//                             onChange={changeVRN}
//                         >

//                         </Select>

//                         <div style={{ display: "none" }}>
//                             <label id="1"> {selectedGroupID} </label>
//                             <label id="2"> {selectedVRN} </label>
//                         </div>
//                     </div>
//                     <div className="modal-footer">
//                         <Button variant="secondary" onClick={closeModel}>Close</Button>
//                         <Button className="btn btn-shell" onClick={onSubmit}>Add</Button>
//                     </div>
//                 </form>
//             </Modal.Body>
//         </Modal>

//         <Accordion>
//             <Row className="m-0">
//                 <Col>
//                     {splitArray.map((el, index) => {
//                         return (
//                             <Card className="card p-3 text-center rounded">
//                                 <Card.Title className="text-left">
//                                     Vehicle Groups
//                                 </Card.Title>

//                                 {el.map((el2, index) => {
//                                     return (
//                                         <div>
//                                             {el2.groupID != '0' ?
//                                                 <ul className="list-inline mb-1 pull-right">
//                                                     <li id={el2.groupID + index}><a href="#" onClick={() => AddCardMapping(el2.groupID, el2.groupName)}><FeatherIcon className="iconspacing" icon="plus-square" size="18" color="green" /></a></li>
//                                                     <li id={el2.groupID + index} className="text-right"><a href="#" onClick={() => EditGroupName(el2.groupID)}><FeatherIcon className="iconspacing" icon="edit" size="18" /></a></li>
//                                                     <li id={el2.groupID + index}><a href="#" onClick={() => DeleteGroup(el2.groupID)}><FeatherIcon className="iconspacing" icon="trash-2" size="18" color="red" /></a></li>
//                                                 </ul>
//                                                 :
//                                                 <div> </div>
//                                             }
//                                             <BoxItemDropDownDownGroup index={index} groupID={el2.groupID} name={el2.groupName} accordionSubItems={el2.vrnModel} deleteDialog='yes' ></BoxItemDropDownDownGroup>
//                                             <hr />
//                                         </div>
//                                     );
//                                 })}
//                             </Card>
//                         );
//                     })}
//                 </Col>
//             </Row>
//         </Accordion>
//     </div>
// );
// }

// function CardChild(props) {
// const items = props.items;
// const indexAccordion = props.indexAccordion;

// return (
//     items.map((el, index) => {
//         return (
//             <div className="box-item btn btn-default w-100">
//                 {/* <BoxItemDropDown index={index} name={el.vrn} accordionSubItems={el.paNs} deleteDialog='no' ></BoxItemDropDown>

//                 <BoxCard index={index} name={el.vrn} accordionSubItems={el.paNs} deleteDialog='no' ></BoxCard> */}
//                 {el.vrn}
//             </div>
//         );
//     })
// );
// }

// function ManageVehicleGroup(props) {
// const [CardMappingData, setCardMappingData] = useState([]);
// const [vrnMappingData, setVRNMappingData] = useState([]);
// const [tagName, setTagName] = useState('');
// const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId);
// const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber);
// const [items, setItems] = useState({
// groupVRN: []
// });

// const history = useHistory();

// function handleBackButtonClick() {
//     history.push('/Manage');
// }

// const [dnd, setDND] = useState({
//     "source": {
//         title: "source",
//         items: []
//     },
//     "dest": {
//         title: "dest",
//         items: []
//     }
// });

// function mapVRNGroupingAPI() {
//     console.log('inside here');

//     let GroupVRN = [];
//     dnd.dest.items.map((el, index) => {
//         GroupVRN.push(el.name);
//     });

//     axiosConfig.post('Portal/VRNGroupMapping', {
//         "CardVRNMappingMasterId": GroupVRN,
//         "GroupName": tagName,
//         "UserBranchID": props.data.selectedBranchId
//     }, {
//         headers: headers
//     })
//         .then((res) => {
//             getVRNMapping();

//             Swal.fire({
//                 icon: 'success',
//                 title: 'Card Grouping Submitted',
//                 text: res.data.status.description,
//             });

//             setDND(prevState => {
//                 return {
//                     ...prevState,
//                     "dest": {
//                         title: "dest",
//                         items: []
//                     }
//                 };
//             });

//             setTagName("");
//         })
//         .catch((error) => {
//             Swal.fire({
//                 icon: 'error',
//                 title: error.response.data.errorMessage
//             });
//         })
//         .finally(() => {
//         });
// }

// function getVCardMapping() {
//     axiosConfig.post('Portal/GetCardMappingForGroup', {
//         "UserBranchID": props.data.selectedBranchId
//     }, {
//         headers: headers
//     })
//         .then((res) => {
//             setCardMappingData(res.data);
//             for (var i = 0; i < res.data.vrnMapping.length; i++) {
//                 setDND(prev => {
//                     return {
//                         ...prev,
//                         source: {
//                             title: "source",
//                             items: [
//                                 {
//                                     id: 'source-' + v4(),
//                                     name: res.data.vrnMapping[i].id,
//                                     caption: res.data.vrnMapping[i].vrn
//                                 },
//                                 ...prev.source.items
//                             ]
//                         }
//                     }
//                 })
//             }
//         })
//         .catch(console.error)
//         .finally(() => {
//             Swal.close();
//         });
// }

// function getVRNMapping() {
//     axiosConfig.post('Portal/GetVRNGroupMapping', {
//         "UserBranchID": props.data.selectedBranchId,
//         "DefaultGroup": false
//     },
//         {
//             headers: headers
//         })
//         .then((res) => {
//             setVRNMappingData(res.data);
//         })
//         .catch(console.error)
//         .finally(() => {
//             //Swal.close();
//         });
// }

// useEffect(() => {
//     Swal.fire({
//         title: 'Please Wait ...',
//         onBeforeOpen() {
//             Swal.showLoading();
//         },
//         onAfterClose() {
//             Swal.hideLoading();
//         },
//         allowOutsideClick: false,
//         allowEscapeKey: false,
//         allowEnterKey: false,
//         showCancelButton: false,
//         showConfirmButton: false
//     });

//     setDND(prevState => {
//         return {
//             ...prevState,
//             "source": {
//                 title: "source",
//                 items: []
//             },
//             "dest": {
//                 title: "dest",
//                 items: []
//             }
//         }
//     });

//     getVCardMapping();
//     getVRNMapping();
// }, [props.data.selectedBranchNumber]);

// const handleDragEnd = ({ destination, source, draggableId }) => {
//     if (destination != null) {
//         if (!destination || !source) {
//             return;
//         }

//         if (source.index === destination.index && source.droppableId === destination.droppableId) {
//             return;
//         }

//         let itemCopy = { ...dnd[source.droppableId].items[source.index] };

//         setDND(prev => {
//             prev = { ...prev };
//             prev[source.droppableId].items.splice(source.index, 1);
//             prev[destination.droppableId].items.splice(destination.index, 0, itemCopy);
//             return prev;
//         });
//     }
// };

// return (
//     <>
//         <Container>
//             <Row className="align-items-center">
//                 <Button variant="warning myBtn" onClick={handleBackButtonClick}>
//                     Back
//                 </Button>
//             </Row>
//             <div>
//                 <h4 className="card-title">
//                     <h4>Manage Vehicle Groups</h4>
//                 </h4>
//             </div>
//             <HeadingBox title="Vehicle Groups enable you to track the performance of your selected vehicles together" />
//             <Row className="m-0">
//                 <DragDropContext onDragEnd={handleDragEnd}>
//                     <Col>
//                         <CardDeck>
//                             <Card key="cardGroup" className="card p-3 text-center rounded" style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
//                                 <Card.Title className="text-left">
//                                     Select Vehicles
//                                 </Card.Title>
//                                 {/* <input id="filter" className="form-control round" type="text" placeholder="Search vehicles in vehicle group..." /> */}
//                                 {dnd.source && <DNDcomponent droppableId="source" droppableKey="vrn" vrndata={dnd.source} showAccordion={false} />}
//                             </Card>
//                             <form onSubmit={() => mapVRNGroupingAPI()}>
//                                 <Card key="vrnGroup" className="card p-3 text-center rounded" style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
//                                     <Card.Title className="text-left">
//                                         <div style={{ marginBottom: 5 }}>Create Vehicle Groups</div>
//                                         <div style={{ marginBottom: 5 }}>
//                                             <small>Please drag vehicles here to make Vehicle Groups.</small>
//                                         </div>
//                                         <input id="filter" className="form-control round" type="text" pattern="^[A-Za-z]+$" placeholder="Enter Group Name" onChange={e => setTagName(e.target.value)} value={tagName} title="Only alphanumeric characters are allowed" required />
//                                     </Card.Title>
//                                     {dnd.dest && <DNDcomponent droppableId="dest" key="mapped" vrndata={dnd.dest} />}
//                                     <Card.Footer>
//                                         <Button className="w-25 text-white" variant="shell" type="submit">Group</Button>
//                                     </Card.Footer>
//                                 </Card>
//                             </form>
//                         </CardDeck>
//                     </Col>
//                 </DragDropContext>
//             </Row>
//             {vrnMappingData.groupVRN && <VRNGroupMappingCard items={vrnMappingData} branchID={props.data.selectedBranchId} mappingData={CardMappingData} setItems={setItems}  />}
//         </Container>
//     </>
// );
// }

// export default ManageVehicleGroup;








